import { useCallback } from 'react';
import { gtmEvents } from '../utils/gtm';
import { useMsId } from '../stores/appStore';
import { useSessionId } from './useSessionId';

export const useGTM = () => {
  const metaSiteId = useMsId();
  const sessionId = useSessionId();

  const trackFunnelEntry = useCallback(
    (page: string) => {
      gtmEvents.funnelEntry({
        page,
        flow: 'ai-create-store',
        userId: sessionId,
      });
    },
    [sessionId],
  );

  const trackPreviewPageView = useCallback(
    (storeName?: string) => {
      gtmEvents.previewPageView({
        metaSiteId: metaSiteId || undefined,
        flow: 'ai-create-store',
        userId: sessionId,
        storeName,
      });
    },
    [metaSiteId, sessionId],
  );

  return {
    trackFunnelEntry,
    trackPreviewPageView,
  };
};

